export default {
    data() {
        return {
            errors: []
        }
    },
    methods: {
        errorHandler(e) {
            this.errors = e.response.data.errors;
            console.log(e.response.data);
            for (let err in this.errors) {
                if (this.errors.hasOwnProperty(err)) {
                    this.$notify({
                        text: this.errors[err][0],
                        type: 'error'
                    });
                }
            }
        },
        clearErrorsContainer() {
            this.errors = [];
        }
    }

}
